module.exports = __webpack_public_path__ + "img/CMO-Tatang-Nurhidayat.b33d0268.jpg";